import React, { useState, useEffect } from "react";
import useQuery from "../../utils/useQuery";
import getApiHeader from "../../utils/getApiHeader";
import { canUseDOM } from "../../utils";
import { authProvider } from "../../services/authProvider";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import store from "../../redux/store/store";

const config = require("../../temp/config");

const PdfPage = ({ Document, Page, pdfjs, header }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState(0);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  return (
    <Document file={header} onLoadSuccess={onDocumentLoadSuccess}>
      {new Array(numPages).fill("").map((item, index) => {
        return (
          <div key={index}>
            <Page width={1000} noData={null} pageNumber={index + 1} />
            <br />
          </div>
        );
      })}
    </Document>
  );
};

const PdfView = ({ lang, fields }) => {
  const [pdfPager, setPdfPager] = useState(null);
  const [pdfInstorePager, setPdfInstorePager] = useState(null);
  useEffect(() => {
    getPdfFile();
  }, []);
  let query = useQuery();
  const getPdfFile = () => {
    getApiHeader().then(headers => {
      let header = {
        url: config.webSettings.apiHostGems + `/gems/api/v1.0/Order/receipt-info-pdf/${query?.type}/${query?.pageFormat}/${query?.orderNo}`,
        httpHeaders: {
          ...headers,
          // "Ocp-Apim-Subscription-Key": config.webSettings.apiKey
        },
        withCredentials: false
      };
      // let pdfParamObj = JSON.parse(window.decodeURIComponent(window.atob(pdfParam)));
      let pdp = {
        url: config.webSettings.apiHostGems + `/gems/api/v1.0/order/receipt/pdf/${query?.orderNo}/${query?.paymentNo}/${query?.pdfCode}/${query?.orgId}/${query?.lang}`,
        httpHeaders: {
          ...headers,
          // "Ocp-Apim-Subscription-Key": config.webSettings.apiKey
        },
        withCredentials: false
      };

      let instoreHeader = {
        url: config.webSettings.apiHostGems + `/gems/api/v1.0/Store/receipt-info-pdf/${query?.type}/${query?.pageFormat}/${query?.orderNo}`,
        httpHeaders: {
          ...headers,
          // "Ocp-Apim-Subscription-Key": config.webSettings.apiKey
        },
        withCredentials: false
      };
      if (query?.orderNo && query?.paymentNo && query?.pdfCode && query?.orgId && query?.lang) {
        showPdpPager(pdp);
      } else {
        showPager(header, instoreHeader);
      }
    });
  };
  const showPdpPager = pdp => {
    import("react-pdf").then(obj => {
      setPdfPager(<PdfPage header={pdp} {...obj} />);
    });
  };
  const showPager = (header, instoreHeader) => {
    import("react-pdf").then(obj => {
      setPdfPager(<PdfPage header={header} {...obj} />);
      setPdfInstorePager(<PdfPage header={instoreHeader} {...obj} />);
    });
  };
  return (
    <>
      {canUseDOM() && (
        <AzureAD provider={authProvider} reduxStore={store}>
          {({ authenticationState }) => {
            return (
              <React.Fragment>
                {authenticationState === AuthenticationState.Unauthenticated && <div style={{ width: "1000px", margin: "auto", marginTop: -70 }}>{pdfPager}</div>}
                {authenticationState === AuthenticationState.Authenticated && <div style={{ width: "1000px", margin: "auto", marginTop: -70 }}>{pdfInstorePager}</div>}
              </React.Fragment>
            );
          }}
        </AzureAD>
      )}
    </>
  );
};

export default PdfView;
